export const DAPP_NAME = "CBDC";
export const SYMBOL_NAME = "CBDC";
export const DAPP_ICON = "https://kalp-cbdc-images.s3.ap-south-1.amazonaws.com/CBDC.png";
export const ADMIN_WALLET_ADDRESS = "675b95716c5289c47535d70bd3700f77619575a6"
export const TransactionName = {
    MINT: "Mint",
    TRANSFER: "Transfer",
    BURN: "Burn",
    APPROVE: "Approve",
    BALANCE: "BalanceOf",
    LOCK: "Lock",
    WHITELIST: "WhitelistUser",
    BLACKLIST: "BlacklistUser",
    INITIALIZE: "Initialize",
    AVAILABLE_TOKENS: "GetAvailableTokens",
    TOTAL_SUPPLY: "TotalSupply",
    REDEEM: "Withdraw"
};